import React, { useState } from 'react';
import { SideBar } from '../organisms';
import { DashboardContainer as DashboardContent } from '../atoms';
import { InternPageHeader, ListOfPlans, PlanForm } from '../organisms';

function PlanosPage() {
  const [ currentPlan, setCurrentPlan ] = useState(null)
  const [refresh, setRefresh] = useState(false);

  return (
    <div className="dashboard-container">
      <SideBar />
      <DashboardContent>
        <div className="row">
          <div className="col-12">
            <InternPageHeader link={"/config/planos"} title={"Cadastro de Planos"} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-5">
            <ListOfPlans refresh={refresh} setRefresh={setRefresh} onSelect={setCurrentPlan} currentPlan={currentPlan}/>
          </div>
          <div className="col-md-7">
            <PlanForm setRefresh={setRefresh} currentPlan={currentPlan} setCurrentPlan={setCurrentPlan} />
          </div>
        </div>
      </DashboardContent>
    </div>
  )
}

export { PlanosPage };
